import React from 'react';
import styles from './BasePage.module.css';
import PageHeader from '../../components/PageHeader/PageHeader';
import SubNav from "../../components/SubNav/SubNav";
import DandadIcon from '../../components/Icons/Dandad/Dandad';
import ScrollToTopButton from '../../components/ScrollToTopButton/ScrollToTopButton';
import CookieBanner from '../../components/CookieBanner/CookieBanner';
import TopNav from "../../components/Nav/TopNav/TopNav";

const BasePage = ({children, subNavLinks, headerClass}) => {
    React.useEffect(() => {
        document.body.classList.remove('no-scroll-init');
    }, []);
    return (
        <>
            <TopNav awardType="professional" />
            <div className={styles.BasePage} >
                <PageHeader headerClass={headerClass} />
                {subNavLinks && <SubNav headerClass={headerClass} links={subNavLinks} />}
                <div className={[styles.BasePageContent, subNavLinks ? styles.BasePageContentWithSubNav : null, headerClass === "theme-report" ? styles.BasePageContentThemeReport : null].join(" ")}>
                    {children}
                </div>
            </div>
            <div className={[styles.IconWrapper, "dandad-icon d-none d-lg-block"].join(" ")}>
                <a href="https://dandad.org/"><DandadIcon /></a>
            </div>
            <ScrollToTopButton />
            <CookieBanner yellow={true} />
        </>
    )
}

export default BasePage;